import { create } from 'zustand';
import type { AppUser } from '../lib/api';
import { authApi, setAccessToken } from '../lib/api';
import { connectSocket, disconnectSocket } from '../lib/socket';

interface AuthState {
  user: AppUser | null;
  accessToken: string | null;
  loading: boolean;
  login: (phone: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  restoreSession: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  loading: true,

  login: async (phone, password) => {
    const { data } = await authApi.login(phone, password);
    setAccessToken(data.accessToken);
    connectSocket(data.accessToken);
    set({ user: data.user, accessToken: data.accessToken });
  },

  logout: async () => {
    try { await authApi.logout(); } catch { /* fire and forget */ }
    setAccessToken(null);
    disconnectSocket();
    set({ user: null, accessToken: null });
  },

  restoreSession: async () => {
    try {
      // Use the httpOnly refresh token cookie to get a new access token
      const { data: refreshData } = await authApi.refresh();
      setAccessToken(refreshData.accessToken);
      const { data: user } = await authApi.me();
      connectSocket(refreshData.accessToken);
      set({ user, accessToken: refreshData.accessToken, loading: false });
    } catch {
      setAccessToken(null);
      set({ loading: false });
    }
  },
}));
